import { Divider } from '@mui/material';

import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export const Container = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: ${theme.spacing(7, 9, 9)};
  background-color: ${theme.palette.grey[900]};
`;

export const Separator = styled(Divider)`
  border-color: ${theme.palette.grey[800]};
  margin: ${theme.spacing(8, 0)};
`;

export const CALL_DETAILS_PARTICIPANT_ICON_WIDTH = '30px';

export const callDetailsExtensionColumnWidth = `calc(100% - ${CALL_DETAILS_PARTICIPANT_ICON_WIDTH} - ${theme.spacing(8)})`;

export const ContainerWrapper = styled('div')`
  margin-top: ${theme.spacing(6)};
`;
